import apiClient from "./apiClient";

export const resolveSaleManually = async (saleId: string, input: {
  action: "IGNORE" | "VALIDATE_MANUALLY";
  userComment?: string | null;
}) => {
  return await apiClient.patch(`/sales/${saleId}/manual-resolution`, input);
};

export type OrphanSaleCandidate = {
  id: string;
  providerId: string;
  name: string;
  accountName: string | null;
  amount: number;
  closeDate: string;
};

export const searchOrphanSales = async (q: string) => {
  return await apiClient.get<OrphanSaleCandidate[]>("sales/orphans", {
    params: { q },
  });
};

